export const FLAGS_UPDATED = 'FLAGS_UPDATED';
